import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {
  Router,
  NavigationEnd,
  NavigationStart,
  NavigationExtras,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { filter } from 'rxjs/operators';

import { DataBusService } from '../data-bus/data-bus.service';
import { SessionServiceService } from '../session-timeout/session-service.service';

@Injectable({
  providedIn: 'root',
})
export class UsergaurdService {
  private route = inject(Router);
  private readonly httpClient = inject(HttpClient);
  router = inject(Router);
  databus = inject(DataBusService);
  session = inject(SessionServiceService);

  constructor() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationStart))
      /* @ts-ignore */
      .subscribe((event: NavigationStart) => {
        if (event.navigationTrigger === 'popstate') {
          console.log('Se detectó un evento');
        }
      });
  }

  private headers: HttpHeaders = new HttpHeaders({
    'Content-Type': 'application/json',
  });

  private url!: string;
  private activesession!: boolean;
  public showsessionoverlay = new Subject<boolean>();
  public getURL() {
    if (
      window &&
      window.location &&
      window.location.host &&
      window.location.protocol
    ) {
      this.url = window.location.protocol + '//' + window.location.host + '/';
      // for local testing
      // this.url = 'http://localhost:8080/';
      return this.url;
    } else {
      this.router.navigate(['/error']);
    }
  }

  public getAuthToken(): Observable<any> {
    const fullUrl =
      this.getURL() + 'MXGCB/apps/renewsession/checkTimeout.action';
    return this.httpClient.get(fullUrl);
  }

  public getWindowName() {
    if (typeof Storage !== 'undefined' && sessionStorage != null) {
      try {
        const wn = sessionStorage.getItem('windowName');
        if (wn != null && wn != '' && wn != 'null') {
          return wn;
        } else {
          return window.name;
        }
      } catch (exception) {
        return window.name;
      }
    } else {
      return window.name;
    }
  }

  canActivate(): Promise<boolean> {
    /* @ts-ignore */
    return this.getAuthToken()
      .toPromise()
      .then((data) => {
        if (data.timeToRenew !== null) {
          if (
            this.getWindowName() == null ||
            this.getWindowName() == '' ||
            this.getWindowName() == 'null' ||
            window.name == null ||
            window.name == ''
          ) {
            if (
              typeof data.jsonResponse.mulSessionWindowName == 'undefined' ||
              data.jsonResponse.mulSessionWindowName == null ||
              data.jsonResponse.mulSessionWindowName == '' ||
              data.jsonResponse.mulSessionWindowName != this.getWindowName()
            ) {
              // Another tab is active - take user to Invalid Tab.do
              window.location.href =
               this.getURL() + '/MXGCB/JPS/portal/InvalidTab.do';
            } else {
              window.location.href =
               this.getURL() + '/MXGCB/JPS/portal/InvalidTab.do';
            }
          } else {
            this.databus.tmpRenewTimer = data.renew;
            const renewTime = data;
            this.session.renewTimer.next(renewTime);
            const now = new Date();
            const time = now.getTime();
            const expireTime = time + 1000 * 48;
            now.setTime(expireTime);
            setTimeout(function () {
              const WID = data.jsonResponse.mulSessionWindowName;
              document.cookie = 'WID=' + WID;
              document.cookie = 'logged=true;expires=Session;path=/';
            }, 1200);
            // session timeOutOverlay data
            this.databus.sessionTimeoutContents = data.timeoutOverlayData;

            return true;
          }
        } else {
          window.location.href =
            this.getURL() + 'MXGCB/apps/logout/flow.action?logOutType=manual';
        }
      });
  }
}
